/**
 * Whether a workspace actually names an organization.
 *
 * The one place to ask, because "unassigned" reaches us in three shapes:
 * `null` from `/workspaces/list`, `undefined` from a `find()` miss, and `""`
 * from a URL segment or a stale cache entry. `buildWorkspaceEntryPath`,
 * `buildClassicWorkspaceEntryPath`, `decide-home-redirect` and
 * `groupWorkspacesForSwitcher` all already treat the empty string as absent;
 * every routing decision must agree, or a workspace with
 * `organization_id: ""` gets a URL of `/dashboard/organization//workspace/…`.
 *
 * Lives in `core` rather than `dashboard` because the classic (Pages Router)
 * console asks the same question, and `core` must never import from
 * `dashboard`.
 */
export function hasOrganizationId(
  value: string | null | undefined
): value is string {
  return value != null && value.trim() !== ""
}
